export default __webpack_public_path__ + "static/media/Header.8e8847c2.svg";